const adapterRegistry = new Map();
export function registerChartAdapter(adapter) {
    if (adapterRegistry.has(adapter.type)) {
        if (process.env.NODE_ENV !== "production") {
            console.warn(`[CompsChart] 图表类型 "${adapter.type}" 已注册，将覆盖现有适配器`);
        }
    }
    adapterRegistry.set(adapter.type, adapter);
}
export function getChartAdapter(type) {
    const adapter = adapterRegistry.get(type);
    if (!adapter) {
        throw new Error(`[CompsChart] 未找到图表类型 "${type}" 的适配器`);
    }
    return adapter;
}
export function isChartTypeRegistered(type) {
    return adapterRegistry.has(type);
}
export function listChartTypes() {
    return Array.from(adapterRegistry.keys());
}
